/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosHeaders } from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "./config";
import { CUSTOMER_SUPPLIER_CONFLICT } from "@/interfaces/customersSuppliers";

declare module "axios" {
  interface AxiosRequestConfig {
    // quem chama trata e exibe o erro por conta própria
    skipErrorToast?: boolean;
  }
}

export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: { AccountId: "NovaCorrente" },
});

function getCookie(name: string) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

export function getTokenAndExpirationStatus(): { token: string | null; expired: boolean } {
  try {
    const tokenDataString = sessionStorage.getItem("token");
    const tokenCookie = getCookie("kasdlgouasdn");
    const expireCookie = getCookie("expireIn");
    const tokenDate = getCookie("tokenDate");

    if (!tokenDataString && !tokenCookie) return { token: null, expired: true };

    const tokenData = (tokenDataString ? JSON.parse(tokenDataString) : null) || tokenCookie;
    const token = tokenData?.token || tokenCookie;
    const expireIn = parseInt(expireCookie || tokenData?.expireIn);
    if (!expireIn) return { token: null, expired: true };

    const dateCreated =
      (tokenData?.dateCreated ? new Date(tokenData.dateCreated).getTime() : null) ||
      Number(tokenDate);

    const expirationTime = dateCreated + expireIn * 1000;
    const expired = Date.now() > expirationTime;
    return { token, expired };
  } catch {
    return { token: null, expired: true };
  }
}

// Interceptor de request
api.interceptors.request.use(
  async (config) => {
    const { token, expired } = getTokenAndExpirationStatus();
    if (token && !expired) {
      // Converte para AxiosHeaders e usa .set()
      const headers =
        config.headers instanceof AxiosHeaders
          ? config.headers
          : new AxiosHeaders(config.headers);

      headers.set("Authorization", `Bearer ${token}`);
      config.headers = headers;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.config?.skipErrorToast) return Promise.reject(error);
    // Conflito de documento do cliente/fornecedor: a tela de origem mostra um modal próprio.
    if (error?.response?.data?.code === CUSTOMER_SUPPLIER_CONFLICT) return Promise.reject(error);
    if (error?.response?.data?.errors) {
      const { errors } = error.response.data;
      errors.forEach((err: { message: string }) => toast.error(err.message));
    } else if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Erro na requisição. Por favor, tente novamente mais tarde.");
    }
    return Promise.reject(error);
  }
);
